import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { normalizeStorageUrl } from './storage-url.util';

@Injectable()
export class StorageUrlRewriteInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map(event => {
        if (!(event instanceof HttpResponse)) {
          return event;
        }

        return event.clone({
          body: this.rewriteStorageUrls(event.body)
        });
      })
    );
  }

  private rewriteStorageUrls(value: any): any {
    if (typeof value === 'string') {
      return normalizeStorageUrl(value);
    }

    if (Array.isArray(value)) {
      return value.map(item => this.rewriteStorageUrls(item));
    }

    if (isPlainObject(value)) {
      return Object.fromEntries(
        Object.entries(value).map(([key, item]) => [key, this.rewriteStorageUrls(item)])
      );
    }

    return value;
  }
}

function isPlainObject(value: any): value is Record<string, any> {
  return Object.prototype.toString.call(value) === '[object Object]';
}
